import { render, staticRenderFns } from "./send_log.vue?vue&type=template&id=47f990ea&scoped=true"
import script from "./send_log.vue?vue&type=script&lang=js"
export * from "./send_log.vue?vue&type=script&lang=js"
import style0 from "./send_log.vue?vue&type=style&index=0&id=47f990ea&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f990ea",
  null
  
)

export default component.exports